export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 4.58,
        "transcript": "Kass'am taungvaurqai ataucim.",
        "translation": "One Caucasian was watching them."
    },
    "2": {
        "startTime": 6.37,
        "endTime": 12.05,
        "transcript": "Caknaallratni tua-i au͡gaasqelluki.",
        "translation": "When they were struggling, he told them to get off."
    },
    "3": {
        "startTime": 12.445,
        "endTime": 24.235,
        "transcript": "Taprarmek waten ikavet pirraarluku muragamek piluku qip'urluki tua-i, waten qip'urluku.",
        "translation": "After placing a rope across like this, he twisted a piece of wood, twisting like this."
    },
    "4": {
        "startTime": 24.535,
        "endTime": 30.755,
        "transcript": "Caknaatellrit yugyagluteng kassuutellinilukek tau͡gaam nurullukek.",
        "translation": "He strung them around through the many people's [?struggles] but came short."
    },
    "5": {
        "startTime": 33.86,
        "endTime": 38.64,
        "transcript": "Amikunek clamp-arlukek Kass'am taum.",
        "translation": "That Caucasian clamped them with hide."
    },
    "6": {
        "startTime": 41.29,
        "endTime": 51.94,
        "transcript": "Tamakut Yupiit clamp-aitellermeggni ussukcautaitellermeggni-llu.",
        "translation": "That was back when Yupiit didn't have clamps or nails."
    },
    "7": {
        "startTime": 56.24,
        "endTime": 57.91,
        "transcript": "Waqaa?",
        "translation": "What is it?"
    },
    "8": {
        "startTime": 59.05,
        "endTime": 65.16,
        "transcript": "Aren, allrakunka-wa... (? ak'allaurte? amllertaritaa?)",
        "translation": "Well, my age... (How old are you now?)"
    },
    "9": {
        "startTime": 66.42,
        "endTime": 70.64,
        "transcript": "Ak'allarpaunrilngua-wa wii.",
        "translation": "I am not very old."
    },
    "10": {
        "startTime": 71.045,
        "endTime": 79.885,
        "transcript": "Kiugna Johnny Samuelson-aaq Cakayak aptaqa allrakuinek qavciuruciinek, allrakunek-wa wiinga nallunilua.",
        "translation": "I asked Johnny Samuelson, Cakayak, his age, saying that I don't know about counting years."
    },
    "11": {
        "startTime": 80.61,
        "endTime": 89.85,
        "transcript": "Tua-i-ll' tuaten allrakunek amllertaniaki piaqa, \"Kitak' wiinga-ll' tuaten allrakungqerkilii amllertalrianek.\"",
        "translation": "Then when he said his age, I said to him, \"Then let me be that age too.\""
    },
    "12": {
        "startTime": 95.055,
        "endTime": 99.45,
        "transcript": "Allrakumnek qanemcitesciigatamken.",
        "translation": "I can't tell you how old I am."
    },
    "13": {
        "startTime": 99.45,
        "endTime": 101.47,
        "transcript": "Nani-mi yuurtellrusit?",
        "translation": "So, where were you born?"
    },
    "14": {
        "startTime": 101.785,
        "endTime": 107.485,
        "transcript": "Yaani-gguq Kuigglugmiuni yuurtellruunga Ceńaqlirni.",
        "translation": "They said I was born over in Kwethluk, in Ceńaqliit [Shore/Riverbank]."
    },
    "15": {
        "startTime": 107.81,
        "endTime": 112.06,
        "transcript": "Qipnermiungulua-llu anglilua.",
        "translation": "And I grew up in Kipnuk."
    },
    "16": {
        "startTime": 112.94,
        "endTime": 124.1,
        "transcript": "Ik'umek-llu tua-i neviarca'rmek tangrriiqngama Anuuraamun ullagluku aipaqsagulluku, ik'umek ika-i aipa'urlumnek.",
        "translation": "And when I had fallen in love with a young lade across there, I went to her in Anuuraaq and married her, my wife across there."
    },
    "17": {
        "startTime": 125.055,
        "endTime": 132.335,
        "transcript": "Neviarcaraullerpeni waten ayagyuallerpeni elpetun tangnirqellruuq kegginaa",
        "translation": "As you are a young lady, she had a pretty face like you"
    },
    "18": {
        "startTime": 133.24,
        "endTime": 139.68,
        "transcript": "Aqlikarangqellruami-llu Yugtarnek pilianek.",
        "translation": "Also because she hand handmade Yup'ik earrings."
    },
    "19": {
        "startTime": 146.615,
        "endTime": 149.395,
        "transcript": "Nutaan-qaa Yugtarnek? (Yaa.)",
        "translation": "Should we move on to Yup'ik things? (Yaa.)"
    },
    "20": {
        "startTime": 150.14,
        "endTime": 161.13,
        "transcript": "Ii-i, kitak' tua-i nutaan alerquastekma imum Yugtarnek alerquutek'lallemnek qanemciqaqernaurtua.",
        "translation": "Okay, let me tell a story about what my instructor taught me about Yup'ik instructions."
    },
    "21": {
        "startTime": 161.56,
        "endTime": 168.14,
        "transcript": "Taktuarpassiyaagmek qalarqurallerkaqa qessayagutaqa.",
        "translation": "I've become disinclined to speak for too long."
    },
    "22": {
        "startTime": 170.005,
        "endTime": 181.775,
        "transcript": "Ellangeqarraallemni imkut qanrutetullruatnga umyuartungnaqlua-gguq usvitungnaqlua yuukilii.",
        "translation": "When I was growing up, they would tell me to try to live life with an alert and wise mind."
    },
    "23": {
        "startTime": 183.675,
        "endTime": 195.145,
        "transcript": "Tua-i-llu angliriama tarricaurcama maani, ikamranun-llu maligucaurcama qanrutnauraatnga waten:",
        "translation": "Then when I had grown and started traveling and going with them on sleds, they would tell me this:"
    },
    "24": {
        "startTime": 196.345,
        "endTime": 207.195,
        "transcript": "Atam-gguq piyaureskuma, unangyaureskuma yuilqurmiutarnek imarpiim-llu unkuum piinek",
        "translation": "They said that when I am able, and I start catching animals from the wilderness and down from the ocean"
    },
    "25": {
        "startTime": 208.605,
        "endTime": 221.745,
        "transcript": "Amirkaq-gguq una atauciq qemangqaurqumku atam-gguq ilangelarniartuq, kiituani-gguq qayangua tua-i.",
        "translation": "If I hold on to this one hide, there will be more, until eventually I have a kayak."
    },
    "26": {
        "startTime": 222.73,
        "endTime": 230.28,
        "transcript": "Tuamtellu-gguq pavani yuilqumi imarmiutarmek wall'u tevyulimek unangekuma",
        "translation": "Then they said that if I catch a mink or muskrat in the wilderness inland"
    },
    "27": {
        "startTime": 231.16,
        "endTime": 236.74,
        "transcript": "Akia-gguq atam qemangqaurqumku egmianun tunevkenaku",
        "translation": "They said that if I hold on to the other side without immediately giving it away"
    },
    "28": {
        "startTime": 237.345,
        "endTime": 245.975,
        "transcript": "Carrarmun-gguq atam nutaan kinguqvaarni ilakangkan tunkumku piluaqerniartua.",
        "translation": "They said that if I have a little bit and there is more later, it will be good if I give it them."
    },
    "29": {
        "startTime": 247.175,
        "endTime": 252.495,
        "transcript": "Imkut tang cap'akit makut ayuqniarutkellrukenka",
        "translation": "You see, I desired these shoes"
    },
    "30": {
        "startTime": 253.85,
        "endTime": 262.97,
        "transcript": "Kass'at cap'akiutait qerrulliit-llu makut nutem taqumalriit lumarracuarauluteng.",
        "translation": "These Western shoes, and these pants that are pre-made out of fabric."
    },
    "31": {
        "startTime": 264.165,
        "endTime": 277.675,
        "transcript": "Tan'gaurluullgutenka au͡gkut aatateng Kass'arqaartelluteng tekitaqata cap'akirluteng, qerrulligluteng lumarracuarnek [?].",
        "translation": "When the fathers of my fellow boys returned after going to the city, they would have shoes, and fabric pants [?]."
    },
    "32": {
        "startTime": 279.885,
        "endTime": 286.695,
        "transcript": "Kamilarma tua-i qerruliyuitellruunga-ll' kiagmi neqlillerni pikailama.",
        "translation": "I would be barefoot, and would not wear pants in the summer at fish camp because I didn't have any."
    },
    "33": {
        "startTime": 287.435,
        "endTime": 298.355,
        "transcript": "Inarteng'e'rma tua-i qavarniiteteullruunga ayuqniarluki tuaten ayuqaitnek pingqeqeryugyaaqlua.",
        "translation": "Though I would go to bed, I would not be sleepy because I desired what they had."
    },
    "34": {
        "startTime": 299.87,
        "endTime": 305.21,
        "transcript": "Maa-i watuam nalliini ik'um pilugulitullruyaaqekiinga.",
        "translation": "Now, [my wife] across there used to make me skin boots."
    },
    "35": {
        "startTime": 305.435,
        "endTime": 312.725,
        "transcript": "Qessayagutanka nat'rait tang tua-i makut qurrayirnaqsuata qanikcarmi.",
        "translation": "I've started rejecting them because their soles are too slippery on snow."
    },
    "36": {
        "startTime": 313.045,
        "endTime": 315.355,
        "transcript": "Ukiyugluteng tuaten.",
        "translation": "They get holes too."
    },
    "37": {
        "startTime": 315.655,
        "endTime": 318.625,
        "transcript": "Tua-i waten kiularaqa:",
        "translation": "I respond to her like this:"
    },
    "38": {
        "startTime": 319.505,
        "endTime": 331.635,
        "transcript": "\"Waniw' tua-i makut cap'akit ayuqniarutkessiyaallruamki cuculuki atungnaq'laranka tua-i cap'akit makut.\"",
        "translation": "\"Because I coveted these shoes too much, wanting them too, I try to use these shoes.\""
    },
    "39": {
        "startTime": 334.095,
        "endTime": 344.825,
        "transcript": "Au͡g'um-llu alerquastek'lallma iliita arnam tangvaurarraarlua uluraqkiinga:",
        "translation": "And after one of the women who instructed me watched me, she would [?say] to me:"
    },
    "40": {
        "startTime": 346.075,
        "endTime": 358.535,
        "transcript": "\"Umyugailkuvet, umyugailkuvet ilavnek ayuqniallren egmiuciiqan",
        "translation": "\"If you are mindless, if you are mindless, you will go forward coveting your peers"
    },
    "41": {
        "startTime": 359.97,
        "endTime": 364.99,
        "transcript": "\"Ilaten atu'urkameggnek teguqerrartengraata.\"",
        "translation": "\"Though your peers take what they need.\""
    },
    "42": {
        "startTime": 365.655,
        "endTime": 374.615,
        "transcript": "Tua-i umyugaitelliniama ilanka teguqerrartengraata ayuqniarumallruanka.",
        "translation": "Since I was mindless, I coveted my peers though they took [what they needed]."
    },
    "43": {
        "startTime": 376.63,
        "endTime": 385.64,
        "transcript": "Tau͡gaam tang irniama iliitnek au͡g'umek arcaqerlua cangayulalrianga.",
        "translation": "But, you see, I feel especially displeased with one of my children."
    },
    "44": {
        "startTime": 388.65,
        "endTime": 398.46,
        "transcript": "Makut maa-i akingukarani check-at quyurquranritlinikai.",
        "translation": "Apparently, he's not saving what money he gets through checks."
    },
    "45": {
        "startTime": 399.63,
        "endTime": 406.96,
        "transcript": "Akingukarani check-at imarkilengraata quyurqurquniki",
        "translation": "If he saves what money he gets through even small checks"
    },
    "46": {
        "startTime": 407.67,
        "endTime": 413.98,
        "transcript": "Amllerikata tua-i snuukuuq akilicugngariyaryalliniluku.",
        "translation": "When they accumulate, he'd be bale to pay for a snow machine."
    },
    "47": {
        "startTime": 414.85,
        "endTime": 422.49,
        "transcript": "Massiinaq-llu levaaq akilicugngayalliniluku.",
        "translation": "And he'd be able to pay for a boat motor."
    },
    "48": {
        "startTime": 422.955,
        "endTime": 425.645,
        "transcript": "Anirtima qanrutaitkut",
        "translation": "It's no wonder they tell us"
    },
    "49": {
        "startTime": 425.855,
        "endTime": 437.315,
        "transcript": "Akikaar-gguq kiturtelluku egmianun kiturtelluku tun'urluku kipusviit iluatni canek aturanek",
        "translation": "They said that passing money by, immediately passing money by to whatever is in the stores"
    },
    "50": {
        "startTime": 437.49,
        "endTime": 447.91,
        "transcript": "Cucullerput maligtaquurassiyaagluku umyuarput kiturtelluki-gguq akikaaraput tamakut aklungengaitukut.",
        "translation": "If we follow our minds whims on whatever we want and pass money by on those, we will not have [important] things."
    },
    "51": {
        "startTime": 448.055,
        "endTime": 455.135,
        "transcript": "Angyangengaunata-llu-gguq akitulriamek, massiinangengaunata-llu-gguq akitulriamek.",
        "translation": "They said we wouldn't get an expensive boat, or an expensive motor."
    },
    "52": {
        "startTime": 456.44,
        "endTime": 464.27,
        "transcript": "Taangamek-llu-gguq mer'atukumta akitulriamek aklumek aturngaunata.",
        "translation": "They also said that if we abuse alcohol, we will not have expensive clothes."
    },
    "53": {
        "startTime": 465.01,
        "endTime": 471.23,
        "transcript": "Akusrarutekngamteki-gguq tamakut atu'urkamteńun navrucaryaaqluki.",
        "translation": "They said it's because we use those for mischief, what we would trade for what we need."
    },
    "54": {
        "startTime": 472.045,
        "endTime": 480.255,
        "transcript": "Maa-i nutaan waten angukara'urluurcama tangvagaqa tamana qanruyutellerput.",
        "translation": "Now that I'm an old man, I'm seeing that traditional wisdom that was passed down to us."
    },
    "55": {
        "startTime": 480.925,
        "endTime": 486.205,
        "transcript": "Picimegcetun au͡gkut alerquagiyuitelliniut.",
        "translation": "The people back then evidently did not give baseless instruction."
    },
    "56": {
        "startTime": 486.74,
        "endTime": 496.42,
        "transcript": "Atullmeggnek tau͡gaam ellaita alerquagitulliniut, ciumteńi atullmeggnek.",
        "translation": "Instead, they instruct us on things they've experiences, what they've experienced before us."
    },
    "57": {
        "startTime": 497.185,
        "endTime": 507.455,
        "transcript": "Iliin-llu picurlallerteng aasaqevkenaku, atuusqevkenaku inerquutaqluku picurlallerteng wangkutnun.",
        "translation": "And some didn't keep their mistakes to themselves, but admonished us against committing their mistakes."
    },
    "58": {
        "startTime": 508.375,
        "endTime": 518.135,
        "transcript": "Una-am Min'garalria maani qasgimi qanengssaara'rqan niicugniaqamni qanlartuq",
        "translation": "When I listen to Min'garalris here in the steam houses, he says"
    },
    "59": {
        "startTime": 518.87,
        "endTime": 530.63,
        "transcript": "Angutmek-gguq tan'gaurluullermini tangvallruuq, Qinarmiunguuq Min'garalria, wagg'uq uumek Aassitugarmek",
        "translation": "He said that he watched a man when he was a boy, Min'garalria is from Qinaq, someone they called Aassitugaq."
    },
    "60": {
        "startTime": 531.475,
        "endTime": 540.455,
        "transcript": "Nulirra-wa Marayill'er, qetunraak-wa Nasqunaraankuk, Panigassa'ar, Ayimquutaq-llu.",
        "translation": "His wife was Marayill'er, and their sons were Nasquna'ar, Panigassa'ar, and Ayimquutaq."
    },
    "61": {
        "startTime": 541.85,
        "endTime": 552.8,
        "transcript": "Tua-i-gguq tang angun tangvallrani ca tua-i picuitkacagaryaaqelria, imarpigmi-ll' unani piliqsuunani tua-i.",
        "translation": "He said that that man he watched was not lucky in hunts, and he wouldn't catch a lot down in the ocean."
    },
    "62": {
        "startTime": 553.86,
        "endTime": 560.16,
        "transcript": "Nunamiuni-gguq tau͡gaam tua-i uitaaqluni. Nunamiunguluni.",
        "translation": "Instead, he said that he would be in landlacked places. He lived on the land."
    },
    "63": {
        "startTime": 561.345,
        "endTime": 571.835,
        "transcript": "Tevyulit-gguq, imarmiutaat, melqulegtani allrakurtaarluni amllerni qemangqatulliniluki.",
        "translation": "He said that every year for a long time, he would keep muskrats, minks, and other fur-bearing animals."
    },
    "64": {
        "startTime": 572.045,
        "endTime": 582.755,
        "transcript": "Angyaicuunani-gguq tau͡gken qayaicuunani-ll' imkunek amirkanek amilegnek, angyat-llu maklagnek amilget.",
        "translation": "However, he said that he always had a boat, and always had a kayak made of seal skin, and those seal skin boats."
    },
    "65": {
        "startTime": 582.995,
        "endTime": 585.11,
        "transcript": "Angyaicuunani-gguq.",
        "translation": "He said he always had a boat."
    },
    "66": {
        "startTime": 585.11,
        "endTime": 596.1,
        "transcript": "Tamakut-gguq tamaa-i unangkengarani qemangqalliniamiki pikanrurtaqata angyarkanun tun'aqluni, qayarkanun-llu tun'aqluki.",
        "translation": "He said that because he kept whatever he caught, he would sell them for boats and sell them for kayaks when he had enough."
    },
    "67": {
        "startTime": 598.19,
        "endTime": 611.39,
        "transcript": "Qanrutetullruitkut, \"Yuungnaquralriit-gguq nulirqelriit Kass'artaitellrani imumi, atiita ikamracualleraak makuk taqkunikek",
        "translation": "They would tell us, 'Back when a married couple made their own living when there were no Caucasians, if he finished their fathers small sled"
    },
    "68": {
        "startTime": 612.545,
        "endTime": 621.405,
        "transcript": "\"Qanikciurun-llu muragaq taqkuniu, piqertuutacualler-llu qel'kekuniu, cikuliurun-llu",
        "translation": "\"And if he finishes a wooden shoever, and holds on to a small axe, and an ice chisel"
    },
    "69": {
        "startTime": 622.47,
        "endTime": 631.35,
        "transcript": "\"Tua-i-gguq teguyarangqerciquq tauna family-t ata'urluat arrsaunge'rmi.\"",
        "translation": "\"They will be able to have things, even if that family's poor father is poor.\""
    },
    "70": {
        "startTime": 632.235,
        "endTime": 641.525,
        "transcript": "Neqkarcuun-llu-gguq qalu quarruugnek unangetuli qemangqakuniu",
        "translation": "He also said that if he keeps that fishing dipnet that catches sticklebacks"
    },
    "71": {
        "startTime": 642.075,
        "endTime": 647.935,
        "transcript": "Unarcianek-llu-gguq taluyitukuni neqkanek unangyugngalrianek",
        "translation": "And he said that if he makes fish traps out of straight-grained pieces of wood that catch fish"
    },
    "72": {
        "startTime": 648.18,
        "endTime": 655.5,
        "transcript": "Imarmiutarnek-llu unangyugngalrianek taluyaruanek-gguq civcitukuni",
        "translation": "And if he sets fishtrap-like traps to catch minks"
    },
    "73": {
        "startTime": 656.455,
        "endTime": 662.965,
        "transcript": "Arrsaunge'rmi-gguq tukurlirpagtun ayuqluni family-t atatekaktni",
        "translation": "He said that even if he's poor, if he acts as a rich father of a family"
    },
    "74": {
        "startTime": 663.455,
        "endTime": 673.095,
        "transcript": "Irniani cirivkarluki aturarrliqengraata aulukciqai pinirillrata yaavet engeliinun.",
        "translation": "If he gives his children an abundance of things, even if they have ragged clothes, he will take care of them until they are strong enough [to do so by themseles] in the future."
    },
    "75": {
        "startTime": 675.06,
        "endTime": 680.59,
        "transcript": "Kass'artaitellrani makut maa-i qanruyutelput.",
        "translation": "This is the traditional wisdom passed down to us before Western contact."
    },
    "76": {
        "startTime": 681.66,
        "endTime": 689.73,
        "transcript": "Tangtullruunga-llu wangkuta tua-i arrsagni ayuqemteńek.",
        "translation": "I also used to see people who were as poor as we were."
    },
    "77": {
        "startTime": 690.32,
        "endTime": 702.3,
        "transcript": "Makut tang tua-i tan'gaurlurnek yulget carraquinermi tau͡gaam iqluluteng arrsaunguaqatullinilriit.",
        "translation": "People who have male children and have little mistakenly believe that they are poor."
    },
    "78": {
        "startTime": 703.535,
        "endTime": 717.365,
        "transcript": "Qetenrateng makut pissuryaurtaqata melqulegcuryaurtaqata, ata'urluat tuk'uqerrnaurtut patagmek melqulek akikeggillrani.",
        "translation": "When their sons started hunting and trapping fur bearing animals, their fathers would suddenly become rich when fur was expensive."
    },
    "79": {
        "startTime": 718.945,
        "endTime": 730.685,
        "transcript": "Unaken call' unguvalrianek tua-i taguquringartaqameng arrsaucillrat imna tua-i nalluyagutnaqluni, ayuqnianarqaqluteng tau͡gaam.",
        "translation": "Also, when they start bringing in animals down from the ocean, we forget that they are poor, and instead want to be like them."
    },
    "80": {
        "startTime": 731.18,
        "endTime": 744.65,
        "transcript": "Atameggnek aulukestekegciaqameng unangkengait tamakut kiturcetevkenaki amlleriluki tau͡gaam tun'arkauluki piaqameng.",
        "translation": "When they have fathers who take care of them well, and they do not pass by what they had caught, but instead sell them."
    },
    "81": {
        "startTime": 745.69,
        "endTime": 755.73,
        "transcript": "Tuamtell' qanernaurtut, \"Anngaqelriit-gguq ukut family-t waten nukalpiat tallimauyaaqeciqut",
        "translation": "And then they would say, \"There may be five brothers in this family who are great hunters"
    },
    "82": {
        "startTime": 756.915,
        "endTime": 764.125,
        "transcript": "\"Una-llu-gguq cali nulirqelriik atauciuyaaqeciquk qetunraak",
        "translation": "\"And this married couple may only have one son"
    },
    "83": {
        "startTime": 764.555,
        "endTime": 775.155,
        "transcript": "\"Uum-gguq qetunraagnek taukut ayuqniarluki anngaqelriit talliman nukalpiat qessalertevkenani",
        "translation": "\"If the couple's son wishes to be like those five brothers who are great hunters and is not lazy"
    },
    "84": {
        "startTime": 775.33,
        "endTime": 785.64,
        "transcript": "\"Nalluatgun inglukluki pingnatukuni ukut-gguq pitacirciqai talliman nukalpiat.\"",
        "translation": "\"If he competes without their knowledge by subsisting, he will become as great as those five great hunters.\""
    },
    "85": {
        "startTime": 785.71,
        "endTime": 795.79,
        "transcript": "Talliman-gguq nukalpiat nalluatni inguklerkaat qacignarquq. Nuvkutaagutetuut-gguq ukut anngaqellriit.",
        "translation": "They say that it's easy to compete against great hunters without their knowledge. They say that brothers argue."
    },
    "86": {
        "startTime": 796.255,
        "endTime": 804.795,
        "transcript": "\"Pi-gguq kuvyayaqili.\" \"Wii kuvyayaryuumiitua.\" \"Pi-gguq muragcuqili.\" \"Wii muragcuryuumiitua.\"",
        "translation": "\"Tell him to fish with a drift net.\" \"I don't want to fish with a gill net.\" \"Tell him to gather wood.\" \"I don't want to gather wood.\""
    },
    "87": {
        "startTime": 805.06,
        "endTime": 810.08,
        "transcript": "Maa-i-gguq makut qacignarqutiit ayagnerat iquat.",
        "translation": "This is what they mean about how it's easy."
    },
    "88": {
        "startTime": 810.145,
        "endTime": 815.76,
        "transcript": "Uum-gguq atauciunge'rmi ayuqeliyugngai ingluliluki.",
        "translation": "They say that even one person can compete with them on their level."
    },
    "89": {
        "startTime": 815.76,
        "endTime": 823.45,
        "transcript": "Makut maa-i qanruqurauteput ellangyugallemteńi Kass'anek makunek piitellermeggni.",
        "translation": "These are what we were told in our early childhoods when there were no Caucasians."
    },
    "90": {
        "startTime": 823.94,
        "endTime": 836.38,
        "transcript": "Neviarcaraat-ll' makut uingeksailnguut angliyartullrat maliggluku ayuqucirtuutnek nutaan patutullruit inerquutnek.",
        "translation": "And these young ladies who were not married, as they got older, they gave them a lot of instructions and admonishments."
    },
    "91": {
        "startTime": 837.525,
        "endTime": 848.795,
        "transcript": "Agurrluk'-llu yuut tangvanrilkiitni nukalpianun unugmi narukitautesqevkenaki inerquraqluki.",
        "translation": "And they would admonish them against ever meeting great hunters at night while people aren't watching."
    },
    "92": {
        "startTime": 849.815,
        "endTime": 858.635,
        "transcript": "Wangkuta-llu unugmi neviarcaraat akuliitnun narukitautesqevkenata.",
        "translation": "They also told us not to meet young ladies at night."
    },
    "93": {
        "startTime": 860.48,
        "endTime": 872.63,
        "transcript": "Alegyagulluku-gguq nasaurluq yugnek tangvagtaitnitekluta kemga agtuqumteggu wangkutnek-gguq tuquciiqukut.",
        "translation": "They said that if we become confident and take a girl because people aren't watching, we will bring death upon ourselves."
    },
    "94": {
        "startTime": 872.88,
        "endTime": 875.92,
        "transcript": "Nulirruarluta tua-i.",
        "translation": "We \"pretend to have wives.\""
    },
    "95": {
        "startTime": 876.295,
        "endTime": 880.455,
        "transcript": "Tamaa-i tam' alingnarcarluku qanrutkaat.",
        "translation": "They talked about that to have us fear it."
    },
    "96": {
        "startTime": 880.99,
        "endTime": 889.29,
        "transcript": "Arnat-llu makut enemi agleraqata qanrutnaurait, \"Kitak' waknirnerk ayagluten tua-i aglertuten.",
        "translation": "And when girls had their first menstruations at home, they would tell them, \"Now, from here, you menstruate."
    },
    "97": {
        "startTime": 889.805,
        "endTime": 899.325,
        "transcript": "\"Nulirtuqsailnguq yun'erra'ar tan'gaurluq anuqiin asguakun agurrluk' kituryaqunaku, waten avaggun tau͡gaam uqrakun.",
        "translation": "\"Never pass an unmarried young man, a boy, upwind from him, but over there downwind like this."
    },
    "98": {
        "startTime": 899.57,
        "endTime": 909.88,
        "transcript": "\"Tepen-gguq atam narluku narumangniaraa. Assiiruyutekaa-gguq kiituan.\"",
        "translation": "\"If he smells your emanations, he will get addicted to it. Eventually, it will ruin him.\""
    },
    "99": {
        "startTime": 910.66,
        "endTime": 915.74,
        "transcript": "Tuaten-qaa qanrucuitellruatgen? (Qanrutaqluta.)",
        "translation": "Would they tell you that? (They would tell us.)"
    },
    "100": {
        "startTime": 915.745,
        "endTime": 917.54,
        "transcript": "Au͡gna-q' elitaqenritan?",
        "translation": "Don't you recognize that?"
    },
    "101": {
        "startTime": 917.54,
        "endTime": 920.66,
        "transcript": "Qang'a, elitaqkacagarluku.",
        "translation": "No, I recognize it completely."
    },
    "102": {
        "startTime": 920.665,
        "endTime": 922.935,
        "transcript": "Tepii-gguq narluku.",
        "translation": "They say he smells her emanations."
    },
    "103": {
        "startTime": 926.655,
        "endTime": 936.295,
        "transcript": "Tua-ll' waniwa mat'umek ak'allarmek-llu ayuqucirtuutmek qanqaasqaqatnga umyuamkun kiulartua",
        "translation": "Then now, when they tell me to speak about old traditional instructions, I reply in my mind"
    },
    "104": {
        "startTime": 936.53,
        "endTime": 946.25,
        "transcript": "\"Kingurautuq man'a ayuqucirtuutellerput wangkuta avani Kass'artangvailgan. Kingurautuq.\"",
        "translation": "\"Our traditional instruction back before Western contact is late. It's late.\""
    },
    "105": {
        "startTime": 946.685,
        "endTime": 958.075,
        "transcript": "Makut tang tua-i tangvallrenka makut eyinqigutet ayagyuat Kass'at tau͡gaam mat'umun tua-i yuungnaquciatnun ekelriit.",
        "translation": "You see, the young children of the next generation that I see are now getting into the Western way of life."
    },
    "106": {
        "startTime": 959.515,
        "endTime": 972.465,
        "transcript": "Man'a-llu Yupiit ellangutait aanameng aatameng-llu qaneryaraat Yugtaq language-aaq man' Kass'at apqiit temciqutaqluku tua-i.",
        "translation": "They also make fun of the Yupik language that Yupiit, their mothers and fathers, grew up with, what they call a language in English."
    },
    "107": {
        "startTime": 972.645,
        "endTime": 976.995,
        "transcript": "Qitevterrlainaryaraq tau͡gaam cucuyagulluku tua-i.",
        "translation": "Instead, they choose to speak only in English."
    },
    "108": {
        "startTime": 977.875,
        "endTime": 987.305,
        "transcript": "Taumek man'a maa-i ayuqucirturillerkaqa ayuqucirtuutellemteńek au͡gkunek qalartellerkaqa",
        "translation": "That's why when I should be instructing on our traditional instructions, and speaking on them"
    },
    "109": {
        "startTime": 988.005,
        "endTime": 996.185,
        "transcript": "Kingurausngaluku tua-i umyuartequsngakeka. Tengrukevkenaku-llu ayuqucirtuutekelqa.",
        "translation": "I started thinking that it's too late. Neither am I excited to teach what I was instructed."
    },
    "110": {
        "startTime": 996.22,
        "endTime": 1004.99,
        "transcript": "Yuum iliin niicugnirraarlua uluqunia pegciiqngaku tamana qanemcikelqa qigcikevkenaku.",
        "translation": "Because after some people listen to me, if he looks away, he will drop it without respecting my stories."
    },
    "111": {
        "startTime": 1005.12,
        "endTime": 1011.79,
        "transcript": "Kass'aq tau͡gaam tangerquniu nutaan ayuqucilinqiggluni quuyurmi qitevvluni ullagciqaa.",
        "translation": "But when he sees a Caucasian, he will change, smile, and go to him speaking English."
    },
    "112": {
        "startTime": 1011.87,
        "endTime": 1016.55,
        "transcript": "Ayuqucirtuutellrenka-ll' au͡gkut nalluyagulluki tua-i umyuaqevkenaki.",
        "translation": "And he forgets what I instructed, does not remember them."
    },
    "113": {
        "startTime": 1017.165,
        "endTime": 1030.605,
        "transcript": "Wangkuta tau͡gken au͡gkut ava-i qanrutkelput egmianun-gguq camek akikuine'rmek melqulegmek tegumiangekumta kiturcequavkenaku.",
        "translation": "But what we were told was that if we come into possession of fur that is worth some money, not to let it pass by."
    },
    "114": {
        "startTime": 1031.12,
        "endTime": 1037.12,
        "transcript": "Qemangqauraqaqerlaut-gguq ilangnercirluku.",
        "translation": "They said that we should keep it until there's more."
    },
    "115": {
        "startTime": 1037.305,
        "endTime": 1047.285,
        "transcript": "Atam-gguq ilangekuni nutaan tunkumteggu carrarnek amllernek ikayuutekamtek unangutekniarput.",
        "translation": "They said that if there's more and we sell a lot of even little things, we will get helpful things from them."
    },
    "116": {
        "startTime": 1047.85,
        "endTime": 1052.89,
        "transcript": "Wall'u qanrutaanga au͡g'um caqerlua ap'ama iliita",
        "translation": "Or, one time, one of my grandfathers said to me"
    },
    "117": {
        "startTime": 1052.895,
        "endTime": 1061.635,
        "transcript": "\"Kitak' maklaarcaureskuvet atam kiturceterrlainarpek'naki atam.",
        "translation": "\"Now, when you start hunting seals, do not keep letting them pass you by."
    },
    "118": {
        "startTime": 1061.82,
        "endTime": 1071.21,
        "transcript": "\"Amirkaq atauciq qemangqaurquvgu atam piinanermini ilangluni, kiituan qayarkanrurciiquq.\"",
        "translation": "\"If you keep even one hide, there will come more, until eventually you have enough to make a kayak.\""
    },
    "119": {
        "startTime": 1071.6,
        "endTime": 1076.65,
        "transcript": "Watuam nalliini imarmiutaat akikeggiameng",
        "translation": "Since mink skins are worth less these days"
    },
    "120": {
        "startTime": 1077.44,
        "endTime": 1089.1,
        "transcript": "Imarmiutaat tau͡gaam melqulget akiitgun kipusvigmi amirkat tua-i qacignariluteng melqulegnek nav'errluki.",
        "translation": "It's become easy to trade mink skins in stores, trading in fur."
    },
    "121": {
        "startTime": 1089.415,
        "endTime": 1093.935,
        "transcript": "Alqunaq tua-i qayarkanrurpallagaqluteng tua-i.",
        "translation": "They suddenly get enough for kayaks."
    },
    "122": {
        "startTime": 1095.98,
        "endTime": 1106.71,
        "transcript": "Mat'umek maa-i qayartangnanrirluteng au͡g'umek ciuliartarmek qalartellerkaqa tengrukenri'rqa.",
        "translation": "Since they've stopped using kayaks, I am no longer excited to talk about our ancestors' ways."
    },
    "123": {
        "startTime": 1107.99,
        "endTime": 1114.42,
        "transcript": "Tangvagluku makut, ukut-llu wii ayuqucirtuq'nganka irnianka tua-i",
        "translation": "Watching these, including my children whom I instruct"
    },
    "124": {
        "startTime": 1114.65,
        "endTime": 1127.74,
        "transcript": "Irniama tuar waniw' ukut qetunrama ayuqucirtuutet tamakut ayuqucirturiyaaqaqama piksaileng'e'rmeng tailuteng tuar qanqa patulaqiit.",
        "translation": "When I teach those traditional instructions, even though my children, my sons, do not [physically] do it, it seems they come and close my mouth."
    },
    "125": {
        "startTime": 1128.71,
        "endTime": 1139.71,
        "transcript": "Au͡gna ayuqucirtuutnek maligtaquingnaqelqa ayuqelinripakaatgu ukut irniama tua-i alerquaqengama.",
        "translation": "It's because my children whom I teach do not follow those traditional teachings."
    },
    "126": {
        "startTime": 1139.875,
        "endTime": 1142.945,
        "transcript": "Tamaa-i tamana puqialutekluku.",
        "translation": "That's why I feel inarticulate."
    },
    "127": {
        "startTime": 1143.595,
        "endTime": 1152.645,
        "transcript": "Ciuliartarmek ayuqucirturiyung'e'rma tua-i mat'umek Kass'at apqiitnek late-aartuq.",
        "translation": "Though I want teach our ancestors ways, it is late, as they say in English."
    },
    "128": {
        "startTime": 1153.525,
        "endTime": 1163.415,
        "transcript": "Tutgaraanka-ll' ukut iliini quyungqaqa'arqata ayuqucirturraarluki aptelaranka, \"Au͡gna-qaa ayuqucirtulqa taringarci?\"",
        "translation": "And sometimes, after I teach my grandchildren when they're gathered, I ask them, \"Do you understand my instruction?\""
    },
    "129": {
        "startTime": 1163.795,
        "endTime": 1173.985,
        "transcript": "\"Ung'alu,\" taringenritaatnga-gguq Yugtun qalarulluki ayuqucirtuutelput.",
        "translation": "\"Ung'alu,\" they say they didn't understand what I had been taught when I speak to them in Yup'ik."
    },
    "130": {
        "startTime": 1175.715,
        "endTime": 1179.905,
        "transcript": "Tua-i tang qanelngulrianga. Waten pitaqatartua.",
        "translation": "Well, I'm tired of speaking. This is all I'll say."
    },
    "131": {
        "startTime": 1179.965,
        "endTime": 1187.635,
        "transcript": "KYUK-t kiugkut qanemcilriit cangirnaqluteng qavcirrarnek Yup'igtun qanqalartut.",
        "translation": "I want more when they tell a few stories upriver in KYUK in Yup'ik."
    }
};